const P = "/api";
export const backendAPIRoutes = {
    users: {
        login: `${P}/user/login/`,
    },
    dashboard: {
        myProfile: `${P}/dashboard/users/me`,
        analytics: `${P}/dashboard/analytics`,
        allUsers: `${P}/dashboard/users`,
        reports: {
            list: `${P}/dashboard/reports`,
            detail: (report_id: string) => `${P}/dashboard/reports/${report_id}`,
        },
        scenarios: {
            allScenarios: `${P}/dashboard/scenarios/`,
            scenarioDetail: (id: string) => `${P}/dashboard/scenarios/${id}`,
            activeScenarios: `${P}/dashboard/scenarios/active`,
            activeScenarioDetail: (id: string) => `${P}/dashboard/scenarios/active/${id}`,
            endScenario: (id: string) => `${P}/exercises/actives/${id}/end`,
        },
        users: {
            detail: (id: string) => `${P}/dashboard/users/${id}/details`,
            reports: (id: string) => `${P}/dashboard/users/${id}/report`,
            changePassword: (id: string) => `${P}/users/${id}/change-password/`,
            update: (id: string) => `${P}/dashboard/users/${id}/update`,
        },
    },
    avatar: {
        list: `${P}/user/avatar/list/`,
    },
};